import './ComparisonEquipments.css';const comparisonEquipments = "_comparisonEquipments_sis1n_1";
const styles = {
  comparisonEquipments
};
export {
  comparisonEquipments,
  styles as default
};
